import { useContext } from 'react';
import { AppScopeContext } from './app-scope-context';

export const useAppScope = () => {
  return useContext(AppScopeContext);
};
